import { buildPackageList } from 'ui-shared/WrappedInputs/Packages/BasePackageList'
import RentPackageCreate from './RentPackageCreate'
import RentPackageEdit from './RentPackageEdit'

const rentPackageIndex = {
  list: buildPackageList('rents'),
  edit: RentPackageEdit,
  create: RentPackageCreate,
}

export default rentPackageIndex
